"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfeFramework = void 0;
/**
 * Copyright 2021 Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const locale_provider_1 = require("../i18n/locale-provider");
const supported_locales_utility_1 = require("../i18n/supported-locales-utility");
const preferred_locale_store_1 = require("../i18n/preferred-locale-store");
const link_navigation_handler_1 = require("../navigation/link-navigation-handler");
const current_user_handler_1 = require("../users/current-user-handler");
const toggles_provider_1 = require("../toggles/toggles-provider");
const toasts_provider_1 = require("../toasts/provider/toasts.provider");
const environment_holder_1 = require("../environment/environment-holder");
class MfeFramework {
    constructor() {
        this.locales = locale_provider_1.Locales;
        this.supportedLocales = supported_locales_utility_1.SupportedLocales;
        this.preferredLocale = preferred_locale_store_1.PreferredLocale;
        this.linkNavigator = link_navigation_handler_1.LinkNavigator;
        this.currentUser = current_user_handler_1.CurrentUser;
        this.toggles = toggles_provider_1.Toggles;
        this.toasts = toasts_provider_1.Toasts;
        this.environment = environment_holder_1.Environment;
    }
    get Locales() {
        return this.locales;
    }
    get SupportedLocales() {
        return this.supportedLocales;
    }
    get PreferredLocale() {
        return this.preferredLocale;
    }
    get LinkNavigator() {
        return this.linkNavigator;
    }
    get CurrentUser() {
        return this.currentUser;
    }
    get Toggles() {
        return this.toggles;
    }
    get Toasts() {
        return this.toasts;
    }
    get Environment() {
        return this.environment;
    }
    static get registeredApplications() {
        return this._registeredApplications.map(a => a);
    }
    setRegisteredApplications(apps) {
        MfeFramework._registeredApplications = apps.map(a => a);
    }
    static getInstance() {
        if (!MfeFramework.instance) {
            // @ts-ignore
            if (!!window[MfeFramework.SHELL_APP_KEY]) {
                // @ts-ignore
                MfeFramework.instance = window[MfeFramework.SHELL_APP_KEY];
            }
            else {
                MfeFramework.instance = new MfeFramework();
            }
        }
        return MfeFramework.instance;
    }
}
exports.MfeFramework = MfeFramework;
MfeFramework.SINGLE_SPA_PROPS_KEY = 'mfe-framework';
MfeFramework.SHELL_APP_KEY = 'shell';
MfeFramework.DEFAULT_ENVIRONMENT_CODE = 'DEV';
MfeFramework.ENVIRONMENT_KEY = 'environment';
MfeFramework._registeredApplications = [];
//# sourceMappingURL=mfe-framework.js.map